import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WSubVerticalJumpLinksCCD: IClientComponentDefinition = {
  name: 'WSubVerticalJumpLinks',
  load: () => import(/* webpackChunkName: 'WSubVerticalJumpLinks' */ './index'),
}
